export default __webpack_public_path__ + "static/media/fixedAssets.dc098499.svg";